import {EmbedNavigation} from './Embed/EmbedNavigation'
import React from 'react'

import ninchatClient from '../api/NinchatClient'

window.addEventListener('beforeunload', () => ninchatClient.close())

const EmbedMain = (): React.ReactElement => <EmbedNavigation />

export default EmbedMain
